import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const BRAND = {
  navy: "#032352",
  white: "#ffffff",
  grey: "#5B5C5F",
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_64ea7acd-0c30-4417-a1e6-b79a907f7f1d/artifacts/j6b99y2d_IMG_1755.png";

export const currency = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(
    Number.isFinite(n) ? n : 0
  );

// Format a YYYY-MM-DD (or ISO) date string as DD/MM/YYYY
export const fmtDate = (d) => {
  if (!d) return "";
  const [y, m, day] = String(d).slice(0, 10).split("-");
  return `${day}/${m}/${y}`;
};
